export const BOARD = "مجلس الإدارة";

export const SECTION_META = {
  stats: "شريط العدادات",
  about: "النبذة والرسالة",
  why_us: "لماذا تختارنا",
  goals: "أهداف النادي",
  team: "اللجان والفريق",
  mom: "أعضاء الشهر",
  workshops: "الفعاليات والدورات",
  achievements: "الإنجازات",
  contact: "انضم إلينا / تواصل",
  partners: "شركاء النجاح",
  gallery: "شريط الصور",
};

export const DEFAULT_CONTENT = {
  titles: {
    about: "النبذة والرسالة",
    why_us: "لماذا تختار نادي المسرح؟",
    goals: "أهداف النادي",
    team: "اللجان والفريق",
    board: "مجلس الإدارة",
    mom: "أعضاء الشهر",
    workshops: "الفعاليات والدورات",
    achievements: "الإنجازات",
    contact: "انضم إلينا أو تواصل معنا",
    partners: "شركاء النجاح",
    gallery: "من خشبتنا",
  },
  section_order: ["stats", "about", "why_us", "goals", "team", "mom", "workshops", "achievements", "contact", "partners", "gallery"],
  hidden_sections: [],
  easter_egg: true,
  stats: [
    { label: "عضو في النادي", icon: "users", source: "members", value: 0 },
    { label: "لجان متخصصة", icon: "star", source: "committees", value: 0 },
    { label: "مسرحية مقدَّمة", icon: "drama", source: "plays", value: 0 },
    { label: "فعالية ودورة", icon: "book", source: "workshops", value: 0 },
    { label: "إنجاز موثَّق", icon: "sparkles", source: "achievements", value: 0 },
  ],
  committee_list: [
    { name: "لجنة التمثيل والتحدث المسرحي", icon: "drama", image: "/committees/acting.jpg" },
    { name: "لجنة التنظيم والإخراج", icon: "clapperboard", image: "/committees/directing.jpg" },
    { name: "لجنة النصوص والتدريب", icon: "pen", image: "/committees/writing.jpg" },
    { name: "لجنة التوثيق والإعلام", icon: "camera", image: "/committees/media.jpg" },
    { name: "لجنة التصميم وكتابة المحتوى", icon: "palette", image: "/committees/design.jpg" },
  ],
  hero_quote: "المسرح ليس مكاناً نذهب إليه، بل حكايةٌ نعيشها معاً على الخشبة.",
  hero_quote_author: "نادي المسرح",
  why_us_intro: "لأن المسرح أكثر من هواية: هو المكان الذي تكتشف فيه نفسك، وتصنع مع زملائك شيئاً يستحق التصفيق.",
  why_us_roles: ["ممثل", "مخرج", "كاتب نصوص", "منظّم", "مصمم", "إعلامي وموثّق"],
  why_us: [
    { title: "لكل طالب دور", text: "لست مضطراً أن تكون ممثلاً؛ نحتاج مخرجين ومنظمين وكتّاباً ومصممين وإعلاميين. اختر الدور الذي يناسب شخصيتك." },
    { title: "خشبة جامعية حقيقية", text: "تطبيق عملي أمام جمهور الجامعة في عروض النادي وفعالياته الرسمية، لا مجرد نظريات." },
    { title: "ساعات تطوعية معتمدة", text: "مشاركتك تُوثَّق عبر منصة ارتقاء بساعات تطوعية وشهادات تُضاف إلى سجلك الجامعي." },
    { title: "فعاليات ودورات على مدار العام", text: "دورات في التمثيل والإلقاء والإخراج والتنظيم، وفعاليات تُنمّي مهاراتك خطوة بخطوة." },
    { title: "مهارات تبقى معك بعد التخرج", text: "الثقة بالنفس، التحدث أمام الجمهور، العمل الجماعي، والقيادة — مهارات يبحث عنها سوق العمل." },
    { title: "عائلة داخل الجامعة", text: "صداقات وزملاء يشاركونك الشغف، وذكريات لا تُنسى على الخشبة وخلف الستار." },
  ],
  goals_intro: "ما نسعى إليه كنادٍ مسرحي جامعي — خطوة بخطوة، من التدريب إلى خشبة المسرح.",
  goals: [
    "اكتشاف واستقطاب المواهب المسرحية بين طلبة الجامعة، وتهيئة البيئة المناسبة لنموها وتطورها.",
    "صقل مهارات الطلبة في مجالات التمثيل، والإخراج، والتأليف، والإنتاج، والسينوغرافيا، والإضاءة، والصوت، وغيرها من عناصر العمل المسرحي.",
    "إنتاج وتقديم عروض مسرحية نوعية تجمع بين القيمة الفنية والفكرية، وتعكس الإبداع الطلابي.",
    "نشر الثقافة المسرحية وتعزيز حضور المسرح بوصفه فنًا أدائيًا وثقافيًا يسهم في إثراء البيئة الجامعية.",
    "تنمية مهارات الشخصية والقيادة والعمل الجماعي من خلال التجارب المسرحية والمشاريع المشتركة.",
    "إتاحة مساحات حقيقية للمواهب لخوض التجربة المسرحية من التدريب إلى خشبة المسرح.",
    "تفعيل الحركة الثقافية والفنية في الجامعة من خلال الفعاليات والعروض والمبادرات المسرحية.",
    "بناء شراكات وتبادل الخبرات مع الأندية والجهات والمؤسسات المتخصصة في المسرح والفنون الأدائية.",
    "تمثيل جامعة المجمعة في المحافل والمهرجانات المسرحية المحلية والوطنية، والسعي إلى تحقيق حضور تنافسي متميز.",
    "المساهمة في تطوير المشهد المسرحي الجامعي وإعداد جيل من الممارسين القادرين على صناعة أعمال مسرحية احترافية.",
  ],
  team_intro: "تعرّف على كل لجنة: ماذا تفعل، إلى أين تطمح، وماذا تقدّم لك كطالب — ثم اختر مكانك بيننا.",
  committees: {
    "مجلس الإدارة": {
      tagline: "القيادة التي ترفع الستار",
      does: "يرسم رؤية النادي وخططه السنوية، يدير العلاقات مع الجامعة والجهات الخارجية، ويتابع أعمال اللجان وساعات الأعضاء التطوعية عبر منصة ارتقاء.",
      ambition: "أن يكون نادي المسرح النموذج الأول للأندية الطلابية في التنظيم والأثر.",
      gain: "قناة مباشرة لأفكارك ومقترحاتك، وتوثيق رسمي لكل جهدك في النادي.",
    },
    "لجنة التمثيل والتحدث المسرحي": {
      tagline: "قلب الخشبة",
      does: "تدريب الأعضاء على الأداء التمثيلي، الإلقاء، لغة الجسد، والتحكّم بالصوت، مع بروفات منتظمة تجهّز الممثلين للعروض.",
      ambition: "تخريج ممثلين واثقين قادرين على حمل أي عرض جامعي أو خارجي.",
      gain: "ثقة أمام الجمهور، مهارات تحدث وإلقاء تنفعك في العرض التقديمي والمقابلة والحياة.",
    },
    "لجنة النصوص والتدريب": {
      tagline: "من الفكرة إلى النص",
      does: "كتابة وتطوير النصوص المسرحية الهادفة، وإعداد البرامج والدورات التدريبية التي تصقل مهارات أعضاء النادي.",
      ambition: "بناء مكتبة نصوص جامعية أصيلة تُعرض على الخشبة وتُلهم غيرنا.",
      gain: "تتعلم الكتابة الدرامية وبناء الشخصيات، وتحصل على تدريب مستمر يرفع مستواك.",
    },
    "لجنة التنظيم والإخراج": {
      tagline: "العقل المدبّر خلف الستار",
      does: "إخراج العروض وتوزيع الأدوار وإدارة البروفات، وتنظيم الفعاليات من الفكرة حتى التنفيذ: الجدولة، المكان، الفريق، والتشغيل.",
      ambition: "عروض وفعاليات بجودة احترافية تُحفظ في ذاكرة الجامعة.",
      gain: "خبرة عملية في القيادة وإدارة الفرق والمشاريع — أهم ما يبحث عنه سوق العمل.",
    },
    "لجنة التوثيق والإعلام": {
      tagline: "عين النادي وصوته",
      does: "تصوير وتوثيق العروض والبروفات والفعاليات، وإدارة حسابات النادي على X وTikTok، وصناعة محتوى يعكس روح المسرح.",
      ambition: "أن يصل صوت النادي لكل طالب في الجامعة وخارجها.",
      gain: "مهارات التصوير والمونتاج وإدارة المنصات، ومحفظة أعمال حقيقية تعرضها.",
    },
    "لجنة التصميم وكتابة المحتوى": {
      tagline: "هوية النادي البصرية",
      does: "تصميم البوسترات والدعوات والمنشورات، وكتابة المحتوى الإبداعي لجميع منصات النادي وفعالياته.",
      ambition: "هوية بصرية مميزة تجعل أي عمل يحمل توقيع نادي المسرح واضحاً من أول نظرة.",
      gain: "تطوّر مهاراتك في التصميم والكتابة على مشاريع حقيقية تُنشر باسمك.",
    },
  },
  mom_intro: "كل شهر نُكرّم أفضل ثلاثة أعضاء في كل لجنة، ونختار لجنةً واحدة تستحق لقب الأفضل — لأن الشغف يستحق التصفيق.",
  partners_intro: "من يقفون معنا خلف الستار ليكتمل العرض.",
  gallery_intro: "لقطات من عروضنا وبروفاتنا وما يحدث خلف الستار.",
  partners_empty: "نرحّب بشراكات جديدة — تواصل معنا لتكون جزءاً من الحكاية.",
};

export function mergeContent(c) {
  const out = { ...DEFAULT_CONTENT, ...(c || {}) };
  out.titles = { ...DEFAULT_CONTENT.titles, ...(c?.titles || {}) };
  out.committees = { ...DEFAULT_CONTENT.committees };
  Object.entries(c?.committees || {}).forEach(([k, v]) => { out.committees[k] = { ...(DEFAULT_CONTENT.committees[k] || {}), ...v }; });
  if (!Array.isArray(out.committee_list) || out.committee_list.length === 0) out.committee_list = DEFAULT_CONTENT.committee_list;
  const known = DEFAULT_CONTENT.section_order;
  out.section_order = [...(out.section_order || []).filter((s) => known.includes(s)), ...known.filter((s) => !(out.section_order || []).includes(s))];
  out.hidden_sections = out.hidden_sections || [];
  return out;
}

export const committeeNames = (content) => content.committee_list.map((c) => c.name);
